module.exports = __webpack_public_path__ + "img/43_bohle.0dd1d746.jpeg";